import { render, staticRenderFns } from "./UcFixedAssetGeneral.yaml?vue&type=template&id=0ac1162b&component"
import script from "./UcFixedAssetGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports